'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import {
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
  LinkedinIcon,
  WhatsappIcon,
} from 'components/modulab/Icon';
import Button from '../../Button';
import { Container } from '../components-internal/Container';
import { CONTENT_MHG } from '../translations/mhg';
import { ComponentFeedbackAndShare } from '$/(cms)/_modules/cmsService/types';
import { FeLink } from '$/components/FeLink';
import Like from '$/components/icons/Like';
import { useClientContext } from '$/modules/context/client';

type FeedbackAndShareProps = ComponentFeedbackAndShare & {
  url: string;
};

export const FeedbackAndShare: React.FC<FeedbackAndShareProps> = ({
  feedback_question,
  share_text,
  show_feedback_section,
  url,
}) => {
  const { lang } = useClientContext();
  const staticText = CONTENT_MHG.get(lang);
  const voted: boolean = false;
  const sendFeedback = (feedback: string) => {
    console.log(feedback);
  };

  const socialMedia = [
    { name: 'email', icon: <EmailIcon />, link: url },
    {
      name: 'facebook',
      icon: <FacebookIcon />,
      link: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    },
    {
      name: 'whasapp',
      icon: <WhatsappIcon color="var(--colors-neutral-gray-800)" />,
      link: `https://wa.me/?text=${url}`,
    },
    {
      name: 'twitter',
      icon: <TwitterIcon />,
      link: `https://twitter.com/share?url=${url}&text=Check%20this%20out`,
    },
    {
      name: 'linkedin',
      icon: <LinkedinIcon />,
      link: `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
    },
  ];

  return (
    <div className="sectionWrapper mx-auto max-w-screen-2xl gap-4 p-4 bg-transparent md:p-10">
      <div className="mx-auto max-w-[1000px]">
        <Container
          className={`grid grid-cols-1 gap-6 md:gap-0 ${!show_feedback_section ? 'sm:grid-cols-1' : 'sm:grid-cols-2'}`}
        >
          {show_feedback_section && (
            <Container
              xType="padding-x"
              yType="padding-y"
              className="flex flex-col items-center rounded-2xl shadow bg-white sm:rounded-3xl"
            >
              <div className="mb-4 text-gray-800 alpha-body-1">
                {feedback_question}
              </div>
              {!voted ? (
                <div className="flex">
                  <Button
                    onClick={() => sendFeedback('like')}
                    variant="text"
                    className="mr-2 p-4"
                    disabled={voted}
                    endIcon={<Like className="text-secondary" />}
                  />
                  <Button
                    onClick={() => sendFeedback('dislike')}
                    className="p-4"
                    disabled={voted}
                    variant="text"
                    endIcon={<Like className="rotate-180 text-red-dark" />}
                  />
                </div>
              ) : (
                <p className="mt-4 text-gray-800">
                  {staticText.thank_you_for_the_feedback}!
                </p>
              )}
            </Container>
          )}

          <Container
            xType="padding-x"
            yType="padding-y"
            className="flex flex-col items-center align-middle"
          >
            <div className="mb-4 text-center text-gray-800 alpha-body-1">
              {share_text}
            </div>
            <ul className="flex items-center">
              {socialMedia.map((item) => (
                <li key={item.name} className="mr-6 last:mr-0">
                  <FeLink
                    href={item.link}
                    className="flex w-4 cursor-pointer items-center justify-center text-gray-800"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.icon}
                  </FeLink>
                </li>
              ))}
            </ul>
          </Container>
        </Container>
      </div>
    </div>
  );
};
